

; jQuery( document ).ready( function ( $ ) {
	if ( $( '#focus' ).length > 0 ) {
		const swiper1 = new Swiper( '#focus', {
			grabCursor: true,
			pagination: {
				clickable: true,
				type: 'bullets',
				bulletClass: 'swiper-pagination-bullet',
				//激活样式
				bulletActiveClass: 'focus-bullet-active',
				el: '.swiper-pagination-m',
			},
			speed: 1000,
			autoplay: {
				delay: 3000,
			},
			slidesPerView: 1,
			loop: true,
			observer: true
		} );
	}
	if ( $( '#solutions-img' ).length > 0 ) {
		const swiper2 = new Swiper( '#solutions-img', {
			on: {
				slideChangeTransitionEnd: function () {
					$( '.icon-list li' ).removeClass( 'active' );
					$( '.icon-list li' ).eq( this.realIndex ).addClass( 'active' );
				},
			},
			slidesPerView: 1,
			flipEffect: {
				slideShadows: false,
			},
			autoplay: {
				delay: 500000000,
			},
			grabCursor: true,
			// direction: 'vertical',
			// mousewheel: true
		} );
		$( '.icon-list li' ).on( 'tap mouseover touchend', function () {
			swiper2.slideTo( $( this ).data( 'index' ) - 1 );
		} )
	}
	if ( $( '#news-swiper' ).length > 0 ) {
		console.log( $( '#news-swiper' ) );
		const swiper3 = new Swiper( '#news-swiper', {
			on: {
				slideChangeTransitionEnd: function () {
					$( '.news-list li' ).removeClass( 'active' );
					$( '.news-list li' ).eq( this.realIndex ).addClass( 'active' );
				},
			},
			slidesPerView: 1,
			flipEffect: {
				slideShadows: false,
			},
			autoplay: {
				delay: 500000000,
			},
			grabCursor: true,
			direction: 'vertical',
			mousewheel: true
		} );
		$( '.news-list li' ).on( 'tap mousemove touchstart', function () {
			swiper3.slideTo( $( this ).data( 'index' ) );
		} )
	}
	if ( $( '#history-swiper' ).length > 0 ) {
		const swiper4 = new Swiper( '#history-swiper', {
			on: {
				slideChangeTransitionEnd: function () {
					// $( '.news-list li' ).removeClass( 'active' );
					// $( '.news-list li' ).eq( this.realIndex ).addClass( 'active' );
				},
			},
			slidesPerView: 4,
			flipEffect: {
				slideShadows: false,
			},

			grabCursor: true,
			// direction: 'vertical',
			mousewheel: true
		} );
	}
	if ( $( '.news-swiper' ).length > 0 ) {
		const swiper5 = new Swiper( '.news-swiper', {
			on: {
				slideChangeTransitionEnd: function () {
					// $( '.news-list li' ).removeClass( 'active' );
					// $( '.news-list li' ).eq( this.realIndex ).addClass( 'active' );
				},
			},
			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
			},
			autoHeight: true,
			slidesPerView: 1,

		} );
	}
	var owlhis = $( '.history-swiper .owl-carousel' );

	if ( owlhis.length > 0 ) {
		owlhis.owlCarousel( {
			items: 4,
			margin: 0,

			dots: false,
			nav: true, navText: [
				'<svg t="1736958729268" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2365" width="100" height="100"><path d="M750.768 496.071l-431.027-438.278c-6.686-6.798-17.619-6.891-24.42-0.203-6.801 6.686-6.891 17.62-0.203 24.42l419.018 426.066-424.477 424.478c-6.743 6.743-6.743 17.678 0 24.421 3.372 3.372 7.792 5.058 12.211 5.058s8.84-1.687 12.211-5.058l436.584-436.584c6.705-6.705 6.75-17.56 0.102-24.32z" fill="#ffffff" p-id="2366"></path></svg>', '<svg t="1736958729268" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2365" width="100" height="100"><path d="M750.768 496.071l-431.027-438.278c-6.686-6.798-17.619-6.891-24.42-0.203-6.801 6.686-6.891 17.62-0.203 24.42l419.018 426.066-424.477 424.478c-6.743 6.743-6.743 17.678 0 24.421 3.372 3.372 7.792 5.058 12.211 5.058s8.84-1.687 12.211-5.058l436.584-436.584c6.705-6.705 6.75-17.56 0.102-24.32z" fill="#ffffff" p-id="2366"></path></svg>'
			]

		} )

		owlhis.on( 'changed.owl.carousel', function ( event ) {
			var index = event.item.index;
			$( '.dot' ).removeClass( 'active' );
			$( '.dot' ).eq( index ).addClass( 'active' )

		} )
		owlhis.trigger( 'to.owl.carousel', 1 )
	}
	//新闻首页及栏目首页
	var owl = $( '.news-swiper1 .owl-carousel' )
	var dot = $( '.news-slide-pagination .owl-dot' );
	if ( owl.length > 0 ) {
		owl.owlCarousel( { items: 1, } )
		owl.on( 'changed.owl.carousel', function ( event ) {
			dot.eq( event.item.index ).addClass( 'active' ).siblings().removeClass( 'active' )
		} );
		dot.each( function ( index ) {
			$( this ).on( 'click', function () {
				$( this ).addClass( 'active' ).siblings().removeClass( 'active' );
				owl.trigger( 'to.owl.carousel', [ index, 300 ] )
			} )
		} )

	}
} )